import { Grid, Box, Typography } from "@mui/material";
import React from "react";
import {
  ObjektIcon,
  AdresseIcon,
  PersonIcon,
  WorkPlanProps,
  MonteurIcon,
} from "../../utils/types";
import { ArbeitsplanType, UserType } from "../../utils/types";

export const AdresseObjektBauleiter = ({ workPlan, users }: WorkPlanProps) => {
  const bauleiter = users.find(
    (x) => String(x.mitarbeiternummer) === workPlan.bauleiter?.trim()
  );
  return (
    <Grid container spacing={2}>
      {workPlan.objekt && (
        <Grid item xs={12} md={4}>
          <Box display="flex" alignItems="center">
            <ObjektIcon />
            <Typography variant="h6">Objekt</Typography>
          </Box>
          <Typography>{workPlan.objekt_name}</Typography>
          {workPlan.objekt_strasse && (
            <Typography>{workPlan.objekt_strasse}</Typography>
          )}
          {(workPlan.objekt_plz || workPlan.objekt_ort) && (
            <Typography>
              {workPlan.objekt_plz} {workPlan.objekt_ort}
            </Typography>
          )}
          {workPlan.tel_objekt && (
            <Typography>{workPlan.tel_objekt}</Typography>
          )}
          {workPlan.mobil_objekt && (
            <Typography>{workPlan.mobil_objekt}</Typography>
          )}
        </Grid>
      )}
      {workPlan.adresse && (
        <Grid item xs={12} md={4}>
          <Box display="flex" alignItems="center">
            <AdresseIcon />
            <Typography variant="h6">Auftraggeber</Typography>
          </Box>
          {workPlan.kunde_name && (
            <Typography>{workPlan.kunde_name}</Typography>
          )}
          {workPlan.kunde_strasse && (
            <Typography>{workPlan.kunde_strasse}</Typography>
          )}
          {(workPlan.kunde_plz || workPlan.kunde_ort) && (
            <Typography>
              {workPlan.kunde_plz} {workPlan.kunde_ort}
            </Typography>
          )}
          {workPlan.tel_adresse && (
            <Typography>{workPlan.tel_adresse}</Typography>
          )}
          {workPlan.mobil_adresse && (
            <Typography>{workPlan.mobil_adresse}</Typography>
          )}
        </Grid>
      )}
      {bauleiter && (
        <Grid item xs={12} md={4}>
          <Box display="flex" alignItems="center">
            <MonteurIcon />
            <Typography variant="h6">Bauleiter</Typography>
          </Box>
          {bauleiter.last_name && bauleiter.first_name && (
            <Typography>
              {bauleiter.last_name}, {bauleiter.first_name}
            </Typography>
          )}
          {workPlan.tel_bauleiter && (
            <Typography>{workPlan.tel_bauleiter}</Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
};
